"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyTypeToFormDataExpectedValues = void 0;
const slim_1 = require("@blockprotocol/type-system/slim");
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const default_expected_value_1 = require("./shared/default-expected-value");
const get_expected_value_descriptor_1 = require("./shared/get-expected-value-descriptor");
const propertyTypeToFormDataExpectedValues = (property) => {
    const descriptors = [];
    const customExpectedValues = {};
    const processProperties = ({ oneOf }, parentId) => {
        for (const expectedValue of oneOf) {
            const id = (0, lodash_uniqueid_1.default)();
            if (parentId) {
                const parentData = customExpectedValues[parentId]?.data;
                if (parentData?.typeId !== "array") {
                    throw new Error("Parent must be an array");
                }
                parentData.itemIds.push(id);
            }
            if ("$ref" in expectedValue) {
                customExpectedValues[id] = {
                    id,
                    data: {
                        typeId: expectedValue.$ref,
                    },
                    ...(parentId ? { parentId } : {}),
                };
            }
            else {
                switch (expectedValue.type) {
                    case "array":
                        customExpectedValues[id] = {
                            id,
                            data: {
                                typeId: "array",
                                infinity: !("maxItems" in expectedValue),
                                itemIds: [],
                                minItems: expectedValue.minItems ??
                                    default_expected_value_1.arrayExpectedValueDataDefaults.minItems,
                                maxItems: expectedValue.maxItems ??
                                    default_expected_value_1.arrayExpectedValueDataDefaults.maxItems,
                            },
                            ...(parentId ? { parentId } : {}),
                        };
                        processProperties(expectedValue.items, id);
                        break;
                    case "object":
                        customExpectedValues[id] = {
                            id,
                            data: {
                                typeId: "object",
                                properties: Object.values(expectedValue.properties).flatMap((itemProperty) => {
                                    let propertyId;
                                    let allowArrays = false;
                                    if ("type" in itemProperty) {
                                        allowArrays = true;
                                        propertyId = itemProperty.items.$ref;
                                    }
                                    else {
                                        propertyId = itemProperty.$ref;
                                    }
                                    return {
                                        id: propertyId,
                                        allowArrays,
                                        required: expectedValue.required?.includes((0, slim_1.extractBaseUrl)(propertyId)) ?? false,
                                    };
                                }),
                            },
                            ...(parentId ? { parentId } : {}),
                        };
                        break;
                }
            }
            if (!parentId) {
                descriptors.push((0, get_expected_value_descriptor_1.getExpectedValueDescriptor)(id, customExpectedValues));
            }
        }
    };
    processProperties(property);
    return [descriptors, customExpectedValues];
};
exports.propertyTypeToFormDataExpectedValues = propertyTypeToFormDataExpectedValues;
